import React from 'react';
import { useAppSettings } from '@hud/web-components/theme/settings';
import {
  Button as BaseButton,
  ButtonProps,
} from '@hud/web-components/Button/Button';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import styled from 'styled-components';
import { themeColor } from '@hud/web-components/theme/colors';

const Button = styled(BaseButton)`
  padding: 6px;
  color: ${themeColor('textSecondary')};
`;

export type ThemeButtonProps = ButtonProps;

// An old button to use if wanting to return the light mode
export function OldThemeButton(props: ThemeButtonProps) {
  const { toggleDarkMode } = useAppSettings();

  return (
    <Button {...props} onClick={toggleDarkMode}>
      <HudIcon icon="other.sun" size="20px" />
    </Button>
  );
}

export default function ThemeButton(_: ThemeButtonProps) {
  return null;
}
